import {
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  USER_DETAILS_FAIL,
  USER_DETAILS_REQUEST,
  USER_DETAILS_SUCCESS,
  USER_DETAILS_RESET,
  USER_TENANT_ACCESS_REQUEST,
  USER_TENANT_ACCESS_SUCCESS,
  USER_TENANT_ACCESS_FAIL,
  USER_TENANT_ACCESS_RESET,
  USER_TENANCY_REGISTER_FAIL,
  USER_TENANCY_REGISTER_REQUEST,
  USER_TENANCY_REGISTER_SUCCESS,
  USER_UPDATE_TENANCY_PROFILE_FAIL,
  USER_UPDATE_TENANCY_PROFILE_REQUEST,
  USER_UPDATE_TENANCY_PROFILE_SUCCESS,
  USER_UPDATE_TENANCY_PROFILE_RESET,
  USER_TENANCY_PROFILE_DETAILS_FAIL,
  USER_TENANCY_PROFILE_DETAILS_REQUEST,
  USER_TENANCY_PROFILE_DETAILS_SUCCESS,
  USER_TENANCY_PROFILE_DETAILS_RESET,
  TENANT_DASHBOARD_DETAILS_FAIL,
  TENANT_DASHBOARD_DETAILS_REQUEST,
  TENANT_DASHBOARD_DETAILS_SUCCESS,
  TENANT_DASHBOARD_DETAILS_RESET,
  USER_TENANT_CREATE_REQUEST,
  USER_TENANT_CREATE_SUCCESS,
  USER_TENANT_CREATE_FAIL,
  USER_TENANT_CREATE_RESET,
  USER_TENANT_LIST_REQUEST,
  USER_TENANT_LIST_SUCCESS,
  USER_TENANT_LIST_FAIL,
  TENANT_ANALYTICS_REQUEST,
  TENANT_ANALYTICS_SUCCESS,
  TENANT_ANALYTICS_FAIL,
  TENANT_ANALYTICS_RESET,
  TENANT_LOGO_UPLOAD_REQUEST,
  TENANT_LOGO_UPLOAD_SUCCESS,
  TENANT_LOGO_UPLOAD_FAIL,
  TENANT_LOGO_UPLOAD_RESET,
  USER_PERMISSION_UPDATE_REQUEST,
  USER_PERMISSION_UPDATE_SUCCESS,
  USER_PERMISSION_UPDATE_FAIL,
  USER_PERMISSION_UPDATE_RESET,
  USER_SUSPEND_REQUEST,
  USER_SUSPEND_SUCCESS,
  USER_SUSPEND_FAIL,
  USER_SUSPEND_RESET,
  USER_PASSWORD_RESET_REQUEST,
  USER_PASSWORD_RESET_SUCCESS,
  USER_PASSWORD_RESET_FAIL,
  USER_PASSWORD_RESET_RESET,
  USER_PASSWORD_CHANGE_REQUEST,
  USER_PASSWORD_CHANGE_SUCCESS,
  USER_PASSWORD_CHANGE_FAIL,
  USER_PASSWORD_CHANGE_RESET,
} from '../constants/userConstants.js';

export const userLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_LOGIN_REQUEST:
      return { loading: true };
    case USER_LOGIN_SUCCESS:
      if (action.payload === undefined) {
        action.payload = {};
      }
      return { loading: false, userInfo: action.payload };
    case USER_LOGIN_FAIL:
      return { loading: false, error: action.payload };
    case USER_LOGOUT:
      return {};
    default:
      return state;
  }
};

export const userDetailsReducer = (state = { user: {} }, action) => {
  switch (action.type) {
    case USER_DETAILS_REQUEST:
      return { ...state, loading: true };
    case USER_DETAILS_SUCCESS:
      if (action.payload === undefined) {
        action.payload = {};
      }
      return { loading: false, user: action.payload };
    case USER_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case USER_DETAILS_RESET:
      return { user: {} };
    default:
      return state;
  }
};

export const userTenantAccessReducer = (state = { access: null }, action) => {
  switch (action.type) {
    case USER_TENANT_ACCESS_REQUEST:
      return { loading: true, access: null };
    case USER_TENANT_ACCESS_SUCCESS:
      return { loading: false, access: action.payload };
    case USER_TENANT_ACCESS_FAIL:
      return { loading: false, error: action.payload, access: null };
    case USER_TENANT_ACCESS_RESET:
    case USER_LOGOUT:
      return { access: null };
    default:
      return state;
  }
};
export const tenantDashboardDetailsReducer = (state = { tenant: {} }, action) => {
  switch (action.type) {
    case TENANT_DASHBOARD_DETAILS_REQUEST:
      return { ...state, loading: true };
    case TENANT_DASHBOARD_DETAILS_SUCCESS:
      if (action.payload === undefined) {
        action.payload = {};
      }
      return { loading: false, tenant: action.payload };
    case TENANT_DASHBOARD_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_DASHBOARD_DETAILS_RESET:
    case USER_DETAILS_RESET:
    case USER_LOGOUT:
      return { tenant: {} };
    default:
      return state;
  }
};



export const userTenancyProfileReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_TENANCY_PROFILE_DETAILS_REQUEST:
      return { loading: true }
    case USER_TENANCY_PROFILE_DETAILS_SUCCESS:
      return { loading: false, success: true, userInfoTenancy: action.payload }
    case USER_TENANCY_PROFILE_DETAILS_FAIL:
      return { loading: false, error: action.payload }
    case USER_TENANCY_PROFILE_DETAILS_RESET:
      return {}
    default:
      return state
  }
}

export const userTenancyRegisterReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_TENANCY_REGISTER_REQUEST:
      return { loading: true }
    case USER_TENANCY_REGISTER_SUCCESS:
      return { loading: false, userInfo: action.payload }
    case USER_TENANCY_REGISTER_FAIL:
      return { loading: false, error: action.payload }
    case USER_LOGOUT:
      return {}
    default:
      return state
  }
}




export const userUpdateTenancyProfileReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_UPDATE_TENANCY_PROFILE_REQUEST:
      return { loading: true }
    case USER_UPDATE_TENANCY_PROFILE_SUCCESS:
      return { loading: false, success: true, userInfo: action.payload }
    case USER_UPDATE_TENANCY_PROFILE_FAIL:
      return { loading: false, error: action.payload }
    case USER_UPDATE_TENANCY_PROFILE_RESET:
      return {}
    default:
      return state
  }
}


export const userTenantCreateReducer = (state = {}, action) => {
  //   const { type, payload } = action
  switch (action.type) {
    case USER_TENANT_CREATE_REQUEST:
      return { loading: true };
    case USER_TENANT_CREATE_SUCCESS:
      return { loading: false, userTenant: action.payload, success: true };
    case USER_TENANT_CREATE_RESET:
      return {};
    case USER_TENANT_CREATE_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const userTenantListReducer = (state = { userTenantLists: [] }, action) => {
  //   const { type, payload } = action
  switch (action.type) {
    case USER_TENANT_LIST_REQUEST:
      return { ...state, loading: true }
    case USER_TENANT_LIST_SUCCESS:
      {
        const rows = Array.isArray(action.payload)
          ? action.payload
          : (action.payload?.data || []);
        const pagination = action.payload?.pagination || {
          currentPage: 1,
          totalPages: rows.length ? 1 : 0,
          totalCount: rows.length,
          hasNextPage: false,
          hasPreviousPage: false,
          limit: rows.length || 0,
        };

      return {
        loading: false,
        userTenantLists: rows,
        pagination,
        count: pagination.totalCount,
        pages: pagination.totalPages,
        page: pagination.currentPage,
      }
      }
    case USER_TENANT_LIST_FAIL:
      return { loading: false, error: action.payload }
    default:
      return state
  }
}

/**
 * Tenant Analytics Reducer
 * Manages dashboard analytics data state
 */
export const tenantAnalyticsReducer = (state = { analytics: {} }, action) => {
  switch (action.type) {
    case TENANT_ANALYTICS_REQUEST:
      return { loading: true, analytics: {} };
    case TENANT_ANALYTICS_SUCCESS:
      return { loading: false, analytics: action.payload };
    case TENANT_ANALYTICS_FAIL:
      return { loading: false, error: action.payload, analytics: {} };
    case TENANT_ANALYTICS_RESET:
      return { analytics: {} };
    default:
      return state;
  }
};

/**
 * Tenant Logo Upload Reducer
 * Manages tenant logo upload state
 */
export const tenantLogoUploadReducer = (state = {}, action) => {
  switch (action.type) {
    case TENANT_LOGO_UPLOAD_REQUEST:
      return { loading: true };
    case TENANT_LOGO_UPLOAD_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case TENANT_LOGO_UPLOAD_FAIL:
      return { loading: false, error: action.payload };
    case TENANT_LOGO_UPLOAD_RESET:
      return {};
    default:
      return state;
  }
};

/**
 * User Permission Update Reducer
 */
export const userPermissionUpdateReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_PERMISSION_UPDATE_REQUEST:
      return { loading: true };
    case USER_PERMISSION_UPDATE_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case USER_PERMISSION_UPDATE_FAIL:
      return { loading: false, error: action.payload };
    case USER_PERMISSION_UPDATE_RESET:
      return {};
    default:
      return state;
  }
};

/**
 * User Suspend Reducer
 */
export const userSuspendReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_SUSPEND_REQUEST:
      return { loading: true };
    case USER_SUSPEND_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case USER_SUSPEND_FAIL:
      return { loading: false, error: action.payload };
    case USER_SUSPEND_RESET:
      return {};
    default:
      return state;
  }
};

/**
 * User Password Reset Reducer
 */
export const userPasswordResetReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_PASSWORD_RESET_REQUEST:
      return { loading: true };
    case USER_PASSWORD_RESET_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case USER_PASSWORD_RESET_FAIL:
      return { loading: false, error: action.payload };
    case USER_PASSWORD_RESET_RESET:
      return {};
    default:
      return state;
  }
};

export const userPasswordChangeReducer = (state = {}, action) => {
  switch (action.type) {
    case USER_PASSWORD_CHANGE_REQUEST:
      return { loading: true };
    case USER_PASSWORD_CHANGE_SUCCESS:
      return { loading: false, success: true, data: action.payload };
    case USER_PASSWORD_CHANGE_FAIL:
      return { loading: false, error: action.payload };
    case USER_PASSWORD_CHANGE_RESET:
      return {};
    default:
      return state;
  }
};
